/**
 * Magniberg: click-to-open header submenus.
 *
 * Horizon's <header-menu> opens and closes submenus through its own `toggle` action
 * (wired with on:click in blocks/_header-menu.liquid) and closes on Escape. This adds
 * the two remaining ways to close an open submenu:
 *   - a click anywhere outside the menu
 *   - keyboard focus leaving the menu
 * Both reuse Horizon's toggle by clicking the expanded trigger, so all state stays
 * in header-menu.js.
 *
 * A click on "Cart" is a click outside the menu and closes it. On mobile, opening the
 * cart drawer also closes the menu panel underneath it.
 */

/**
 * @param {Element} menu
 * @returns {HTMLElement | null}
 */
function expandedTrigger(menu) {
  return menu.querySelector('.menu-list__link--toggle[aria-expanded="true"]');
}

/** @param {Element} menu */
function closeMenu(menu) {
  expandedTrigger(menu)?.click();
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  for (const menu of document.querySelectorAll('header-menu')) {
    if (!menu.contains(event.target) && expandedTrigger(menu)) closeMenu(menu);
  }
});

// On mobile the cart drawer opens over the page: close the menu panel underneath it.
document.addEventListener('theme-drawer:open', (event) => {
  if (!(event.target instanceof Element) || event.target.id !== 'cart-drawer') return;

  const menuDrawer = /** @type {(HTMLElement & { isOpen?: boolean, close?: () => void }) | null} */ (
    document.querySelector('header-drawer')
  );
  if (menuDrawer?.isOpen) menuDrawer.close?.();
});

document.addEventListener('focusout', (event) => {
  const menu = event.target instanceof Element ? event.target.closest('header-menu') : null;
  if (!menu || !expandedTrigger(menu)) return;

  const next = event.relatedTarget;
  if (next instanceof Node && !menu.contains(next)) closeMenu(menu);
});
